import { render, staticRenderFns } from "./TimeEntriesStatisticsBarChart.vue?vue&type=template&id=51d9587d&"
import script from "./TimeEntriesStatisticsBarChart.vue?vue&type=script&lang=js&"
export * from "./TimeEntriesStatisticsBarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TimeEntriesStatisticsBarChart.vue"
export default component.exports